import { Checkbox } from '@mui/material';
import React from 'react';

import { checkboxStyles, optionItemStyles } from '@/components/Selector/styles';

import s from './ShowAllToggleOption.module.scss';

type ShowAllToggleOptionProps = {
  checked: boolean;
  onToggle: () => void;
  props: React.HTMLAttributes<HTMLLIElement>;
  margin?: string;
};

export const ShowAllToggleOption: React.FC<ShowAllToggleOptionProps> = ({
  checked,
  onToggle,
  props,
  margin,
}) => {
  return (
    <li
      {...props}
      className={s.toggleOption}
      style={{
        ...props.style,
        ...optionItemStyles,
        ...(margin && { margin }),
      }}
      onMouseDown={(e) => {
        e.preventDefault();
        e.stopPropagation();
        onToggle();
      }}
      onClick={(e) => {
        e.preventDefault();
        e.stopPropagation();
      }}
    >
      <div className={s.option}>
        <Checkbox checked={checked} readOnly disableRipple size="small" sx={checkboxStyles} />
        <div className={s.option_content}>
          <p className={s.toggleOption_label}>Показывать внешних пользователей</p>
        </div>
      </div>
    </li>
  );
};
